import { Component, OnInit, Input } from '@angular/core';
import { SysUsersService } from '../services/sys-users.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-edit-sys-users',
  templateUrl: './edit-sys-users.component.html',
  styleUrls: ['./edit-sys-users.component.scss'],
})
export class EditSysUsersComponent implements OnInit {
  @Input() stationId: any;
  @Input() stationsUser: Array<any>;
  @Input() user: any;
  changePassword = false;
  pickPasswordFormMe = false;
  loading = false;

  constructor(
    private ref: NbDialogRef<EditSysUsersComponent>,
    private userService: SysUsersService,
  ) { }

  ngOnInit() {
  }

  close() {
    this.ref.close();
  }

  async editUser() {

    if (!this.user.stations.length) {
      return Swal.fire({
        icon: 'error',
        title: 'Debe seleccionar al menos una estacion',
        text: '',
      });
    }


    if (this.user.name === '' || this.user.role === '' || this.user.email === '') {
      return Swal.fire({
        icon: 'error',
        title: 'Ingresa todos los datos necesiarios',
        text: '',
      });
    }

    if (this.changePassword === false && this.pickPasswordFormMe === false && (this.user.password === '' || this.user.confirmPassword === '')) {
      return Swal.fire({
        icon: 'error',
        title: 'Ingresa todos los datos necesiarios',
        text: '',
      });
    }


    if (this.pickPasswordFormMe === false && this.user.password !== this.user.confirmPassword) {
      return Swal.fire({
        icon: 'error',
        title: 'Las contraseñas no coinciden',
        text: '',
      });
    }

    if (this.pickPasswordFormMe) {
      this.user.password = 'zeromanito';
      this.user.confirmPassword = 'zeromanito';
    }

    this.loading = true;
    this.user.pickPasswordFormMe = this.pickPasswordFormMe;
    const [error, { data: result }] = await this.userService.updateUser(this.user);
    // tslint:disable-next-line: max-line-length
    if (error) { this.loading = false; return this.alert('Ocurrio un error al intentar actualizar la información, intenta más tarde por favor', 'error'); }
    this.loading = false;
    this.alert(result, 'Usuario actualizado con éxito');
    this.ref.close(true);
  }

  alert(user, title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    let html: string;

    if ('password' in user) {
      html = `Email: <b>${user.email}</b> </br> Contraseña: <b>${user.password}</b>`;
    } else {
      html = `Email: <b>${user.email}</b>`;
    }

    Swal.fire({
      icon: type,
      html: html,
      title: title,
      text: text,
    });
  }
}
